import M$control$ActiveLayersControl from 'C:/proyectos/managelayers/src/facade/js/activelayersControl';
import M$plugin$BaseLayersControl from 'C:/proyectos/managelayers/src/facade/js/baselayersControl';
import M$plugin$ManageLayers from 'C:/proyectos/managelayers/src/facade/js/managelayers';
import M$control$ManageLayersControl from 'C:/proyectos/managelayers/src/facade/js/managelayerscontrol';
import M$control$ThematicLayersControl from 'C:/proyectos/managelayers/src/facade/js/thematiclayersControl';
import M$control$WMCLayersControl from 'C:/proyectos/managelayers/src/facade/js/wmclayersControl';
import M$impl$control$ActiveLayersControl from 'C:/proyectos/managelayers/src/impl/ol/js/activelayersControl';
import M$impl$control$BaseLayersControl from 'C:/proyectos/managelayers/src/impl/ol/js/baselayersControl';
import M$impl$control$ManageLayersControl from 'C:/proyectos/managelayers/src/impl/ol/js/managelayerscontrol';

if (!window.M.control) window.M.control = {};
if (!window.M.plugin) window.M.plugin = {};
if (!window.M.impl) window.M.impl = {};
if (!window.M.impl.control) window.M.impl.control = {};
window.M.control.ActiveLayersControl = M$control$ActiveLayersControl;
window.M.plugin.BaseLayersControl = M$plugin$BaseLayersControl;
window.M.plugin.ManageLayers = M$plugin$ManageLayers;
window.M.control.ManageLayersControl = M$control$ManageLayersControl;
window.M.control.ThematicLayersControl = M$control$ThematicLayersControl;
window.M.control.WMCLayersControl = M$control$WMCLayersControl;
window.M.impl.control.ActiveLayersControl = M$impl$control$ActiveLayersControl;
window.M.impl.control.BaseLayersControl = M$impl$control$BaseLayersControl;
window.M.impl.control.ManageLayersControl = M$impl$control$ManageLayersControl;
